import React from 'react';

export default function useMobile() {
  const mediaMatch = window.matchMedia('(max-width: 600px)');
  const [mobile, setMobile] = React.useState(mediaMatch.matches);

  React.useEffect(() => {
    const handler = e => setMobile(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  });

  return mobile;
}